import React, { useState } from "react";
import swal from "sweetalert";
import { usePost } from "seed/api";
import { useQuery, useSet, useDetail } from "seed/gql";
import { Loading } from "seed/helpers";
import { SET_FLOW_NODE } from "seed/gql/queries";
import l from "components/util/l";
import View from "components/studio/forms/process_form/ProcessFormView.view";

function ProcessFormEdit({
  flowId,
  nodeId,
  onCompletedSubmit = () => { },
  onCompletedDelete = () => { },
}) {

  const [isVisibleRules, setIsVisibleRules] = useState(false);
  const isDeveloper = sessionStorage.getItem("is_developer") == "true";

  const [callDeleteTree] = usePost("/flows/delete_tree", {
    onCompleted: () => {
      onCompletedDelete();
    },
    onError: () => {
      swal("Error", "Ha ocurrido un error al eliminar el proceso, por favor intente de nuevo mas tarde", "error");
    }
  });

  const [callSetFlowNode] = useSet(SET_FLOW_NODE, {
    onCompleted: () => {
      onCompletedSubmit();
    },
    onError: () => {
      swal("Error", l("Ha ocurrido un error al editar el proceso, por favor intente de nuevo mas tarde%SA211"), "error");
    }
  });

  const qRules = useQuery(`{
    flowChatRules {
      content
      settings
      type
    }
  }`, `node.id=${nodeId}`, {  fetchPolicy: "no-cache" });

  const [callSaveRules] = usePost("/flows/set_settings", {
    onCompleted: () => {
      qRules.refetch();
      setIsVisibleRules(false);
    }
  });

  const reqNode = useDetail(`{
    flowNode {
      rootName
      rootDescription
      rootSettings
    }
  }`, nodeId);

  const onSubmitForm = (values) => {
    values.rootSettings.icon = values?.rootSettings?.icon ?? null;
    callSetFlowNode(values);
    callSaveRules({
      flow_id: flowId,
      settings: {
        flow_chat_rules: values.rules.map(rule => ({
          ...rule,
          rule: {
            ...rule.rule,
            node: { id: nodeId },
          }
        })),
      }
    });
  }

  const onClickDelete = () => {
    swal({
      title: l("¿Eliminar proceso?%SA213"),
      text: l("¿Estás seguro de que deseas eliminar este proceso?%SA214"),
      icon: "warning",
      buttons: [l("Cancelar%GA021"), l("Eliminar%GA001")],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        callDeleteTree({ root_node_id: nodeId });
      }
    });
  }

  if (reqNode.loading || qRules.loading) return <Loading />;
  if (reqNode.error || qRules.error) return "Error";

  const { flowNode = {} } = reqNode.data;
  const rules = qRules.data?.flowChatRules || [];
  const wrappedChatRules = rules.map(rule =>
    ({ action: "update", rule }));

  const initialValues = {
    ...flowNode,
    rootSettings: {
      ...flowNode.rootSettings,
      show_suggestion: flowNode.rootSettings.show_suggestion ?? true
    },
    rules: wrappedChatRules
  };

  return (
    <View
      flowId={flowId}
      nodeId={nodeId}
      nodes={[flowNode]}
      initialValues={initialValues}
      isDeveloper={isDeveloper}
      isEditing={true}
      isVisibleRules={isVisibleRules}
      setIsVisibleRules={setIsVisibleRules}
      onSubmit={onSubmitForm}
      onClickDelete={onClickDelete}
    />
  );
}

export default ProcessFormEdit;